function passwordValidator(input) {
  const isValid = input.length >= 6;

  return isValid;
}

export default passwordValidator;
